import 'arrive/src/arrive';
import bsModal from 'bootstrap/js/dist/modal';
import { bpHelper } from './utils';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

function openWhenReady(frameId, isRemote, openFn, timeoutMs = 2000) {
  const frame = document.getElementById(frameId);

  // Inline content (trigger without data-turbo-stream) is rendered once
  // server-side and never refetched: clearing it would leave the modal
  // permanently empty (TW-2303). Open it as-is right away.
  if (!frame || !isRemote) { openFn(); return; }

  // Remote-loaded frame: clear stale content so the modal waits for the fresh
  // response instead of briefly showing the previous one (happens when multiple
  // buttons share the same frame_id, e.g. "J'ai trouvé" + "message groupé").

  frame.innerHTML = '';

  let fired = false;
  const fire = () => {
    if (fired) return;
    fired = true;
    observer.disconnect();
    clearTimeout(timeoutId);
    openFn();
  };
  const observer = new MutationObserver(fire);
  observer.observe(frame, { childList: true });
  const timeoutId = setTimeout(fire, timeoutMs);
}

document.arrive('.modal-canvas-button', function(element) {
  element.addEventListener('click', () => {
    const id = element.dataset.id;
    // Documented contract (see /design_system?selected=modal): remote-loaded
    // modals put data-turbo-stream='true' on the trigger, inline ones don't.
    const isRemote = element.dataset.turboStream === 'true';

    if (bpHelper.isMatching('md', true)) {
      const offcanvasElement = document.querySelector(`.offcanvas-container-${id}`);
      const offCanvas = Offcanvas.getOrCreateInstance(offcanvasElement);

      openWhenReady(`canvas-content-${id}`, isRemote, () => {
        $('.offcanvas').offcanvas('hide');
        offCanvas.show();
      });
    } else {
      const modalElement = document.getElementById(`modal-container-${id}`);
      const modal = bsModal.getOrCreateInstance(modalElement);

      openWhenReady(`modal-content-${id}`, isRemote, () => modal.show());
    }
  });
});
